import { differenceInHours, differenceInMinutes, format } from 'date-fns'
import { UrlParts } from 'settings/notificationsService'
import { DateFormats, parseISODate } from 'utils/dates'
import { t } from 'translations'

export function notificationActionUrl(urlParts: UrlParts) {
    switch (urlParts.type) {
        case 'codes':
            return !!urlParts.subtype && urlParts.subtype === 'coupons'
                ? `/account/${urlParts.accountSlug}/venue/codes/coupons/upload/${urlParts.uuid}`
                : `/account/${urlParts.accountSlug}/venue/codes/tickets/upload/${urlParts.id}`
        case 'products':
            return `/account/${urlParts.accountSlug}/products/validity/${urlParts.uuid}/detail`
        default:
            return '/'
    }
}

export function notificationActionPermission(urlParts: UrlParts) {
    return urlParts.type === 'codes' ? 'access_codes' : 'partner_admin'
}

export function notificationTimeLabel(dateString: string | Date) {
    const date = parseISODate(dateString)
    const difference = differenceInHours(new Date(), date)
    if (difference < 1) {
        return t('settings.notifications.feed.minutesAgo', { minutes: differenceInMinutes(new Date(), date) })
    }
    return difference > 24
        ? format(date, `${DateFormats.EXTRA_SHORT_DATE} ${DateFormats.SHORT_TIME}`)
        : t('settings.notifications.feed.hoursAgo', { hours: difference })
}
